
import React, { FC, useEffect } from 'react';
import { Input } from 'antd';
import { getAutoCode } from '@/common/asset-apis/assetModel';
import { useUpdateEffect, useDebounceEffect } from 'ahooks';
import memo from '../memo';

interface AssetTextAutoFillValueProps {
  params: any;
  funcName?: string;
  value?: any;
  onChange?: any;
  SystemAPI?: any;
  disabled?: boolean;
  /** 无参自动补全 */
  isAutoCodeNoPrefix?: boolean;
  allowClear?: boolean;
}

export const AssetTextAutoFillValue: FC<AssetTextAutoFillValueProps> = ({
  params,
  funcName,
  value,
  onChange,
  SystemAPI,
  disabled,
  isAutoCodeNoPrefix,
  allowClear,
}) => {
  const getValue = () => {
    // 没有前缀的情况下也获取
    if (isAutoCodeNoPrefix || (!isAutoCodeNoPrefix && params?.prefix)) {
      getAutoCode(SystemAPI, params, funcName).then((res: any) => {
        const [e, data] = res;
        onChange(data?.data?.data);
      });
    }
  };

  // 忽略第一次加载，后续变更覆盖值
  useUpdateEffect(() => {
    getValue();
  }, [JSON.stringify(params), isAutoCodeNoPrefix]);

  // 第一次加载，判定是否有值
  useDebounceEffect(() => {
    if (params && !value) {
      getValue();
    }
  }, [params, value], { wait: 500 });


  return (
    <Input value={value} disabled={disabled} allowClear={allowClear !== false} />
  );
};

export default React.memo(AssetTextAutoFillValue, (prevProps, nextProps) => {
  if (JSON.stringify(prevProps) === JSON.stringify(nextProps)) {
    return true;
  }
  return false;
});
